/**
 * Actions for the Captcha subcomponent.
 *
 * The action is used for analytics, to track usage of CAPTCHA across a site.
 */
export var CaptchaAction;
(function (CaptchaAction) {
    /**
     * Indicates that the member is signing in.
     */
    CaptchaAction["MemberSignIn"] = "MemberSignIn";
    /**
     * Indicates that the patron is creating a new member.
     */
    CaptchaAction["MemberSignUp"] = "MemberSignUp";
    /**
     * Indicates that the member is resetting their forgotten password.
     */
    CaptchaAction["ResetMemberPassword"] = "ResetMemberPassword";
    /**
     * Indicates that the member is updating their password.
     */
    CaptchaAction["UpdateMemberPassword"] = "UpdateMemberPassword";
    /**
     * Indicates that the member is updating their username.
     */
    CaptchaAction["UpdateMemberUsername"] = "UpdateMemberUsername";
    /**
     * Indicates that the member is updating their email address.
     */
    CaptchaAction["UpdateMemberEmail"] = "UpdateMemberEmail";
    /**
     * Indicates that the member is updating their details.
     */
    CaptchaAction["UpdateMemberDetails"] = "UpdateMemberDetails";
    /**
     * Indicates that the patron is checking the details of a gift card.
     */
    CaptchaAction["CheckGiftCard"] = "CheckGiftCard";
    /**
     * Indicates that the patron is checking the availability of a member's email address.
     */
    CaptchaAction["CheckMemberEmail"] = "CheckMemberEmail";
    /**
     * Indicates that a non-standard action is being performed.
     */
    CaptchaAction["Other"] = "Other";
})(CaptchaAction || (CaptchaAction = {}));
//# sourceMappingURL=action.js.map